import { render } from "./DoorIcon.vue?vue&type=template&id=564922d5"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/DoorIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "564922d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('564922d5', __exports__)) {
    api.reload('564922d5', __exports__)
  }
  
  module.hot.accept("./DoorIcon.vue?vue&type=template&id=564922d5", () => {
    api.rerender('564922d5', render)
  })

}


export default __exports__